import { InputAdornment, TextField } from "@mui/material";

const NumberField = ({ unit, digits = 2, value, onChange, ...props }) => {
    let inputProps = {};
    if (!!unit) {
        inputProps.endAdornment = <InputAdornment position="end">{unit}</InputAdornment>;
    }

    return (
        <TextField
            {...props}
            value={value || ""}
            onChange={onChange}
            inputProps={{ style: { textAlign: "right" } }}
            InputProps={inputProps}
        />
    );
};

export default NumberField;
